module.exports = __webpack_public_path__ + "img/medicina.8f623989.png";